import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none",
  viewBox: "0 0 21 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.481 3.665a.833.833 0 0 1 0 1.179 7.292 7.292 0 0 0 0 10.312.833.833 0 1 1-1.178 1.178 8.958 8.958 0 0 1 0-12.669.833.833 0 0 1 1.178 0m9.235 0a.833.833 0 0 1 1.178 0 8.958 8.958 0 0 1 0 12.67.833.833 0 0 1-1.178-1.18 7.292 7.292 0 0 0 0-10.311.833.833 0 0 1 0-1.179M8.189 6.33a.833.833 0 0 1 0 1.178 3.525 3.525 0 0 0 0 4.985.833.833 0 0 1-1.178 1.178 5.191 5.191 0 0 1 0-7.341.833.833 0 0 1 1.178 0m3.819 0a.833.833 0 0 1 1.178 0 5.191 5.191 0 0 1 0 7.341.833.833 0 0 1-1.178-1.178 3.525 3.525 0 0 0 0-4.985.833.833 0 0 1 0-1.178M9.058 10a1.042 1.042 0 1 1 2.084 0 1.042 1.042 0 0 1-2.084 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }